"use strict";
/* globals module */
/**
 * @module notificationsRegistrationsAnonymousClient
 * @description  Notifications Registrations Anonymous Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsRegistrationsAnonymousClient` uses `notificationsRegistrationsAnonymousRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var httpApi_1 = require("../../httpApi");
;
var _1 = require("./");
var NotificationsRegistrationsAnonymousClient = /** @class */ (function () {
    function NotificationsRegistrationsAnonymousClient(notificationsRegistrationsAnonymousRoute, notificationsRegistrationsAnonymousBatchClient, apiClient) {
        this.notificationsRegistrationsAnonymousRoute = notificationsRegistrationsAnonymousRoute;
        this.notificationsRegistrationsAnonymousBatchClient = notificationsRegistrationsAnonymousBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsRegistrationsAnonymousClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRegistrationsAnonymousRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsAnonymousClient.prototype, "batch", {
        get: function () {
            return this.notificationsRegistrationsAnonymousBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create anonymous registration action has been performed; this action creates a new anonymous registration resource.
     * @method
     * @param data An AnonymousRegistration object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create anonymous registration action has been performed.
     * @example notificationsRegistrationsAnonymousClient.create({
                    provider: '<provider-name>',
                    providerdata: <provider-data>,
                    expirationData: '<expiration-date>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsRegistrationsAnonymousClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of anonymous registration resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example notificationsRegistrationsAnonymousClient.find({
                   pageNumber : 1,
                   pageSize : 10,
                   orderBy : '<field>',
                   orderDirection : '<asc|desc>',
                   search : '<search-phrase>',
                   providers: '<provider-name1>,<provider-name2>',
                   embed: '<embed>'
               })
               .then(function (collection) {
                   // perform success action here
               },
                function (response, status, headers, config) {
                    // perform error handling here
               });
    */
    NotificationsRegistrationsAnonymousClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified anonymous registration resource.
     * @method
     * @param id The registration identifier which uniquely identifies AnonymousRegistration resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example notificationsRegistrationsAnonymousClient.get('<registration-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsRegistrationsAnonymousClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.notificationsRegistrationsAnonymousRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the remove anonymous registration action has been performed. This action will remove a anonymous registration resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsRegistrationsAnonymousRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(registration);
     * var uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An object used to delete specified AnonymousRegistration resource.
     * @returns A promise that is resolved once the remove anonymous registration action has been performed.
     * @example // registration is a resource previously fetched using get action.
                    notificationsRegistrationsAnonymousClient.remove(registration)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsRegistrationsAnonymousClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update anonymous registration action has been performed; this action updates a anonymous registration resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsRegistrationsAnonymousRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(registration);
     * var uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An object used to update specified AnonymousRegistration resource.
     * @returns A promise that is resolved once the update anonymous registration action has been performed
     * @example // registration is a resource previously fetched using get action.
                        subscription.provider = '<provider-name>';
                        notificationsRegistrationsAnonymousClient.update(registration)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     */
    NotificationsRegistrationsAnonymousClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b, _c;
    NotificationsRegistrationsAnonymousClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsRegistrationsAnonymousRoute !== "undefined" && _1.NotificationsRegistrationsAnonymousRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsAnonymousBatchClient !== "undefined" && _1.NotificationsRegistrationsAnonymousBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], NotificationsRegistrationsAnonymousClient);
    return NotificationsRegistrationsAnonymousClient;
}());
exports.NotificationsRegistrationsAnonymousClient = NotificationsRegistrationsAnonymousClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
